import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { fetchData, imageBaseURL } from "../../utils/fetchData";
import { getAPIPath } from "../../utils/getDomainData";

const SliderDefault = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.home_slider, setData);
  }, []);
  const sliderSettings = {
    dots: false,
    centerMode: false,
    autoplay: true,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="rs-slider main-home">
        <Slider {...sliderSettings}>
          {data?.data?.map((slide) => (
            <div key={slide.id}>
              <div className="slider-content">
              <div className="bgMedia">
                  {slide.attributes.Image.data.attributes.url.includes('.mp4') ? (
                    <video width="100%" height="100%" autoPlay loop muted>
                      <source src={imageBaseURL + slide.attributes.Image.data.attributes.url} type="video/mp4" />
                    </video>
                  ) : (

                    <img src={imageBaseURL + slide.attributes.Image.data.attributes.url}  title={slide.attributes.Image.data.attributes.alternativeText} alt={slide.attributes.Image.data.attributes.alternativeText}  />
                  )
                  }
                </div>
                <div className="fixedBannerTitle">
                  <div className="container">
                    <div className="content-part">
                      <h2 className="sl-title" title={slide.attributes.Heading}>{slide.attributes.Heading}</h2>
                      <div className="sl-sub-title" dangerouslySetInnerHTML={{ __html: slide.attributes.Sub_Heading,}}/>
                        <div className="sl-btn" style={{ visibility: slide?.attributes?.External_Link !== null ? 'visible' : 'hidden' }}>
                          <a
                            className="readon orange-btn main-home"
                            href={slide?.attributes?.External_Link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {slide?.attributes?.Button_Text}
                          </a>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </React.Fragment>
  );
};

export default SliderDefault;
